import React from "react"
import cx from "classnames"

type Props = {
  className?: string
  height?: number
  width?: number
  fill: string
}

function Triangle({ className, height, width, fill }: Props) {
  return (
    <svg
      className={cx(className)}
      height={height}
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 10 5"
    >
      <path d="M0 0L5 5L10 0H0Z" fill={fill} />
    </svg>
  )
}

export default Triangle
